import React, { useState } from 'react'
import { MenuOutlined, TranslationOutlined, UserOutlined, ExportOutlined, SettingOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { logout } from '../../apis/auth'
import { setAdmin, setLogoutAdmin } from '../../store/adminSlice'
import { setLogout, setUser } from '../../store/userSlice'
import { useTranslation } from 'react-i18next'
import { ColMenu, CustomMenuDropdown, Logo, MenuItem, MenuWrapper, Separator, ToggleWrapper, Wrapper } from './header.styled'
import { ROUTES } from '../../constants/Routing'
import { Button, ConfigProvider, Dropdown, Modal, Select, Tooltip } from 'antd'
import { CHECKAUTH } from '../../constants/ActionTypes'
import useLogo from '../../hook/useLogo'

function Header (props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t: ln_t } = useTranslation()
  const { layoutConf, showSidebar, setShowSidebar, setChangeGroupLoading } = props
  const admin = useSelector((state) => state.admin)
  const user = useSelector((state) => state.user)
  const location = useLocation()
  const { pathname } = location || {}
  const adminMode = pathname.includes(ROUTES.ADMIN_ROOT)
  const { name, language, groups, nowGroup, brands, nowBrand } = user || {}
  const [changeGroup, setChangeGroup] = useState(false)
  const logo = useLogo({ blackMode: true, height: '28px' })

  const userItems = [
    { key: 'profile', label: ln_t('util.profile') },
    { key: 'logout', label: ln_t('util.signOut') }
  ]
  const languageItems = [{ key: 'zh-TW', label: ln_t('util.language.zh-tw') }, { key: 'en', label: ln_t('util.language.en') }]

  const sendLogout = async () => {
    const result = await logout()
    if (result?.status === 200) {
      dispatch(adminMode ? setLogoutAdmin() : setLogout())
      navigate(adminMode ? ROUTES.ADMIN_LOGIN : ROUTES.CLIENT_LOGIN)
    }
  }

  const handleProfileChange = (clickedItem) => {
    if (clickedItem.key === 'logout') return sendLogout()
    adminMode ? navigate(ROUTES.ADMIN_PROFILE) : navigate(ROUTES.CLIENT_PROFILE)
  }

  const handleLanguageChange = (clickedItem) => {
    dispatch(adminMode ? setAdmin({ ...admin, language: clickedItem.key }) : setUser({ ...user, language: clickedItem.key }))
  }

  const reload = () => setTimeout(() => {
    navigate(0)
    setChangeGroupLoading(false)
  }, 500)

  const handleChangeBrand = brandId => {
    setChangeGroupLoading(true)
    dispatch(setUser({ ...user, nowBrand: brandId }))
    reload()
  }

  const handleChangeGroup = groupId => {
    setChangeGroupLoading(true)
    dispatch(setUser({ ...user, nowGroup: groupId, nowBrand: 0 }))
    dispatch({ type: CHECKAUTH.REQUEST })
    setChangeGroup(false)
    reload()
  }

  const nowGroupName = groups?.find(i => i.id === nowGroup)?.name
  const otherGroup = groups?.filter(i => i.id !== nowGroup) || []
  const nowBrandObj = brands?.find(i => i.id === nowBrand) || {}
  const otherBrand = brands?.filter(i => i.id !== nowBrand) || []
  const profileRender = menu => adminMode
    ? menu
    : <CustomMenuDropdown>
        <MenuItem color="var(--secondary)">
          {nowGroupName} {otherGroup?.length
            ? <Tooltip title={ln_t('user.switchGroup')}><ExportOutlined className="hoverable" onClick={() => setChangeGroup(true)} /></Tooltip>
            : ''}
        </MenuItem>
        <MenuItem color="#327e78">
          {nowBrandObj.name} {nowBrandObj.brandUser?.role === 'admin'
            ? <Tooltip title={ln_t('user.goToManagement')}><SettingOutlined className="hoverable" onClick={() => navigate('/brandManagement')} /></Tooltip>
            : ''}
        </MenuItem>
        {otherBrand?.map(i => <MenuItem key={i.id} useBorder><div className="hoverable" onClick={() => handleChangeBrand(i.id)}>{i?.name}</div></MenuItem>)}
        <MenuItem style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <ColMenu width="45%" left onClick={() => handleProfileChange({ key: 'profile' })}>{ln_t('util.profile')}</ColMenu>
          <ColMenu width="55%" onClick={() => handleProfileChange({ key: 'logout' })}>{ln_t('util.signOut')}</ColMenu>
        </MenuItem>
      </CustomMenuDropdown>

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Wrapper height={layoutConf.headerHeight}>
        <ToggleWrapper>
          <MenuOutlined onClick={() => setShowSidebar(!showSidebar)} />
          {!showSidebar
            ? <Logo>{logo}</Logo>
            : ''}
        </ToggleWrapper>
        <MenuWrapper>
          <Dropdown menu={{ items: languageItems, onClick: handleLanguageChange }}>
            <Button type="text" size="small" icon={<TranslationOutlined />}>
              {ln_t(`util.language.${adminMode ? admin?.language?.toLowerCase() : language.toLowerCase()}`)}
            </Button>
          </Dropdown>
          <Separator />
          <Dropdown menu={{ items: userItems, onClick: handleProfileChange }} dropdownRender={profileRender}>
            <Button type="text" size="small" icon={<UserOutlined />}>{adminMode ? admin?.name : name}</Button>
          </Dropdown>
        </MenuWrapper>
      </Wrapper>

      <Modal title={ln_t('user.switchGroup')} open={changeGroup} onCancel={() => setChangeGroup(false)} okButtonProps={{ style: { display: 'none' } }} destroyOnClose>
        <Select
          showSearch
          style={{ width: '100%', margin: '8px 0px' }}
          placeholder={`${ln_t('util.pelaseSelect')} ${ln_t('util.group')}`}
          options={otherGroup?.map(i => ({ value: i.id, label: i.name }))}
          optionFilterProp="children"
          onChange={e => handleChangeGroup(e)}
        />
      </Modal>
    </ConfigProvider>
  )
}

export default Header
